exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-14f42075]{width:100%;max-width:70px;height:auto;-o-object-fit:contain;object-fit:contain}.payment[data-v-14f42075]{padding:10px}.payment[data-v-14f42075]:not(:last-child){border-bottom:1px solid #e0e0e0}.payment--link[data-v-14f42075]{display:-ms-flexbox;display:flex;color:inherit;text-decoration:none}.payment--link:hover p[data-v-14f42075]{text-decoration:underline}.payment__label[data-v-14f42075]{display:block;max-width:70px;line-height:1.2}\n", ""]);

// exports
